import { SelectItem } from 'primeng/api';
import { AdminLocationModel } from 'src/app/model/admin/location';
import { BaseModalModel } from 'src/app/model/core/base-modal';
import { KhuyanaSelectItemModel } from 'src/app/model/core/khuyana-select-item.model';

export interface AdminLocationState {
  queryResult: SelectItem<KhuyanaSelectItemModel>[];
  result: AdminLocationModel[];
  modal: BaseModalModel<AdminLocationModel>;
}

export const adminLocationIS: AdminLocationState = {
  queryResult: [],
  result: [],
  modal: {
    isVisible: false,
    title: '',
    value: {},
  },
};
